import React from 'react'

import { Box } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import useStyles from './styles'

const TrainingCourseCardSkeleton = () => {
  const classes = useStyles()

  return (
    <Box className={classes.card}>
      <Skeleton variant="rect" className={classes.thumbnail} />
      <Box className={classes.body}>
        <Box className={classes.categories}>
          <Skeleton
            variant="rect"
            width={60}
            height={22}
            className={classes.chip}
          />
          <Skeleton
            variant="rect"
            width={40}
            height={22}
            className={classes.chip}
          />
        </Box>
        <Skeleton variant="text" className={classes.title} />
        <Skeleton variant="text" width="80%" className={classes.title} />
        <Box className={classes.meta}>
          <Skeleton variant="text" width={80} className={classes.metaText} />
          <Skeleton variant="text" width={60} className={classes.metaText} />
        </Box>
        <Skeleton variant="rect" className={classes.accessButton} />
      </Box>
    </Box>
  )
}

export default TrainingCourseCardSkeleton
